import hcAxios, { RequestOptions } from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// 实人认证
enum API {
  /** 获取认证结果 @admin */
  RealPersonAuthGetVerifyResult = '/hk-web/realPersonAuth/getVerifyResult',
  /** 回显认证数据 @admin */
  IdentityGetVerifyRecord = '/hk-web/identity/getVerifyRecord',
  /** 个人标准认证-检验 @Peter */
  IdentityStandardCheck = '/hk-web/identity/standard/check',
  /** sumsub生成访问令牌 @Frank */
  KycSumsubAccessTokens = '/hk-web/kyc/sumsub/accessTokens',
  /** 接受Sumsub Webhook事件 @ryan */
  KycSumsubEvents = '/hk-web/kyc/sumsub/events',
  /** 接受Sumsub Webhook事件 @ryan */
  KycSumsubEventsTest = '/hk-web/kyc/sumsub/events/test',
  /** sumsub查询审核结果 @ryan */
  KycSumsubReviewStatus = '/hk-web/kyc/sumsub/reviewStatus',
  /** sumsub生成访问令牌Test @ryan */
  TestKycSumsubAccessTokens = '/hk-web/test/kyc/sumsub/accessTokens',
  /** sumsub查询审核结果 @ryan */
  TestKycSumsubReviewStatus = '/hk-web/test/kyc/sumsub/reviewStatus',
  /** 在沙盒中为申请人设置审核 @ryan */
  TestKycSumsubTestCompleted = '/hk-web/test/kyc/sumsub/testCompleted',
  /** amlbot 回调 @ryan */
  KycAmlbotCallback = '/hk-web/kyc/amlbot/callback',
  /** 生成amlbot表单URL @ryan */
  KycAmlbotFormUrl = '/hk-web/kyc/amlbot/formUrl',
  /** 生成amlbot表单URL @ryan */
  TestKycAmlbotFormUrl = '/hk-web/test/kyc/amlbot/formUrl',
  /** amlbot初始化数据 @ryan */
  KycAmlbotInitAuthentication = '/hk-web/kyc/amlbot/init/authentication',
  /** 获取认证token @admin */
  RealPersonAuthGetVerifyToken = '/hk-web/realPersonAuth/getVerifyToken',
  /** 企业认证-提交审核 @admin */
  IdentityCompanyApply = '/hk-web/identity/company/apply',
  /** 企业认证-查询上传文件草稿 @admin */
  IdentityCompanyFilesInfo = '/hk-web/identity/company/filesInfo',
  /** 企业认证-保存上传文件草稿 @admin */
  IdentityCompanySaveFiles = '/hk-web/identity/company/saveFiles',
  /** 个人标准认证 @admin */
  IdentityStandardApply = '/hk-web/identity/standard/apply',
  /** 个人高级认证 @admin */
  IdentityAdvancedApply = '/hk-web/identity/advanced/apply',
  /** 企业认证-查询认证最终收益权人草稿 @admin */
  IdentityCompanyBeneficiaryInfo = '/hk-web/identity/company/beneficiaryInfo',
  /** 企业认证-查询认证董事草稿 @admin */
  IdentityCompanyDirectorInfo = '/hk-web/identity/company/directorInfo',
  /** 企业认证-保存认证最终收益权人草稿 @admin */
  IdentityCompanySaveBeneficiary = '/hk-web/identity/company/saveBeneficiary',
  /** 企业认证-保存认证董事草稿 @admin */
  IdentityCompanySaveDirector = '/hk-web/identity/company/saveDirector',
  /** 企业认证-保存认证账户交易员草稿 @admin */
  IdentityCompanySaveTrader = '/hk-web/identity/company/saveTrader',
  /** 企业认证-查询认证账户交易员草稿 @admin */
  IdentityCompanyTraderInfo = '/hk-web/identity/company/traderInfo',
  /** 用户认证状态 @admin */
  IdentityStatus = '/hk-web/identity/status',
  /** 查看不同用户类型所拥有的权益 @admin */
  IdentityGetUserRights = '/hk-web/identity/getUserRights',
  /** 查询认证结果 @admin */
  IdentityGetVerifyResult = '/hk-web/identity/getVerifyResult',
  /** 企业认证-查询基础信息草稿 @admin */
  IdentityCompanyBasicInfo = '/hk-web/identity/company/basicInfo',
  /** 企业认证-保存基础信息草稿 @admin */
  IdentityCompanySaveBasicInfo = '/hk-web/identity/company/saveBasicInfo',
  /** 企业认证-示例文件展示 @admin */
  IdentityCompanyTemplateFile = '/hk-web/identity/company/templateFile',
}

export type TGetRealPersonAuthGetVerifyResultParams = any
export type TGetRealPersonAuthGetVerifyResultResponse = TResponse<any>
export const getRealPersonAuthGetVerifyResult = (
  params?: TGetRealPersonAuthGetVerifyResultParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetRealPersonAuthGetVerifyResultResponse>(API.RealPersonAuthGetVerifyResult, { params, options })
}

export type TGetIdentityGetVerifyRecordParams = {
  /** 身份认证类型 1个人标准认证 2个人高级认证 3企业认证 */
  identityType?: any
  /** uid */
  userId?: any
}
export type TGetIdentityGetVerifyRecordResponse = TResponse<{
  /** 地址证明 */
  addressProof?: string
  /** 出生日期 */
  birthday?: string
  /** BVN */
  bvnCode?: string
  /** 证件背面 */
  cardBackPhotoUrl?: string
  /** 证件正面 */
  cardFrontPhotoUrl?: string
  /** 1-驾驶证 2-身份证 3-护照 4-居留许可证 */
  cardType?: number
  /** 城市 */
  city?: string
  /** 国家或地区，例如中国 传CN */
  country?: string
  /** id */
  id?: number
  /** 证件号 */
  idNo?: string
  /** 姓 */
  lastName?: string
  /** 中间名字 */
  middleName?: string
  /** 姓名 */
  name?: string
  /** 人物信息图片 */
  realPersonPhotoUrl?: string
  /** 地址 */
  street?: string
}>
export const getIdentityGetVerifyRecord = (params?: TGetIdentityGetVerifyRecordParams, options?: RequestOptions) => {
  return hcAxios.get<TGetIdentityGetVerifyRecordResponse>(API.IdentityGetVerifyRecord, { params, options })
}

export type TPostIdentityStandardCheckParams = {
  /** 1-驾驶证 2-身份证 3-护照 4-居留许可证 */
  cardType?: number
  /** 国家或地区，例如中国 传CN */
  country?: string
  /** 证件号 */
  idNo?: string

  userId?: number
}
export type TPostIdentityStandardCheckResponse = TResponse<any>
export const postIdentityStandardCheck = (params?: TPostIdentityStandardCheckParams, options?: RequestOptions) => {
  return hcAxios.post<TPostIdentityStandardCheckResponse>(API.IdentityStandardCheck, params, { options })
}

export type TPostKycSumsubAccessTokensParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostKycSumsubAccessTokensResponse = TResponse<string>
export const postKycSumsubAccessTokens = (params?: TPostKycSumsubAccessTokensParams, options?: RequestOptions) => {
  return hcAxios.post<TPostKycSumsubAccessTokensResponse>(API.KycSumsubAccessTokens, params, { options })
}

export type TPostKycSumsubEventsParams = string
export type TPostKycSumsubEventsResponse = TResponse<string>
export const postKycSumsubEvents = (params?: TPostKycSumsubEventsParams, options?: RequestOptions) => {
  return hcAxios.post<TPostKycSumsubEventsResponse>(API.KycSumsubEvents, params, { options })
}

export type TPostKycSumsubEventsTestParams = string
export type TPostKycSumsubEventsTestResponse = TResponse<string>
export const postKycSumsubEventsTest = (params?: TPostKycSumsubEventsTestParams, options?: RequestOptions) => {
  return hcAxios.post<TPostKycSumsubEventsTestResponse>(API.KycSumsubEventsTest, params, { options })
}

export type TPostKycSumsubReviewStatusParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostKycSumsubReviewStatusResponse = TResponse<{
  /** 对同一验证级别上的当前验证尝试进行计数 */
  attemptCnt?: string
  /** 当前验证尝试的唯一标识符 */
  attemptId?: string
  /** 创建时间 */
  createDate?: string
  /** 申请人验证传递到状态后经过的时间 */
  elapsedSincePendingMs?: string
  /** 申请人验证传递到状态后阻塞的时间 */
  elapsedSinceQueuedMs?: string
  /** 自动检测模式 */
  levelAutoCheckMode?: string
  /** KYC级别 */
  levelName?: string
  /** 优先级 */
  priority?: string
  /** 重新处理 */
  reprocessing?: string
  /** 审核时间 */
  reviewDate?: string
  /** 审核唯一标识符 */
  reviewId?: string
  /** sumsub审核结果VO */
  reviewResult?: {
    /** 拒绝原因，不得向申请人显示 */
    clientComment?: string
    /** 审核评论，可以向申请人显示 */
    moderationComment?: string
    /** 一个或多个拒绝原因 */
    rejectLabels?: string[]
    /** 审阅结果 GREEN 申请人获得批准；RED 申请人被拒绝 */
    reviewAnswer?: string
    /** 指示拒绝的类型 FINAL 最终拒绝；RETRY 暂时拒绝 */
    reviewRejectType?: string
  }
  /** 审核状态 */
  reviewStatus?: string
}>
export const postKycSumsubReviewStatus = (params?: TPostKycSumsubReviewStatusParams, options?: RequestOptions) => {
  return hcAxios.post<TPostKycSumsubReviewStatusResponse>(API.KycSumsubReviewStatus, params, { options })
}

export type TPostTestKycSumsubAccessTokensParams = {
  /** 1-驾驶证 2-身份证 3-护照 4-居留许可证 */
  cardType?: number

  country?: string

  externalUserId?: string

  userId?: number
}
export type TPostTestKycSumsubAccessTokensResponse = TResponse<{
  /** 唯一申请人ID */
  externalUserId?: string
  /** 访问令牌 */
  token?: string
}>
export const postTestKycSumsubAccessTokens = (
  params?: TPostTestKycSumsubAccessTokensParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostTestKycSumsubAccessTokensResponse>(API.TestKycSumsubAccessTokens, params, { options })
}

export type TPostTestKycSumsubReviewStatusParams = {
  /** 1-驾驶证 2-身份证 3-护照 4-居留许可证 */
  cardType?: number

  country?: string

  externalUserId?: string

  userId?: number
}
export type TPostTestKycSumsubReviewStatusResponse = TResponse<{
  /** 对同一验证级别上的当前验证尝试进行计数 */
  attemptCnt?: string
  /** 当前验证尝试的唯一标识符 */
  attemptId?: string
  /** 创建时间 */
  createDate?: string
  /** 申请人验证传递到状态后经过的时间 */
  elapsedSincePendingMs?: string
  /** 申请人验证传递到状态后阻塞的时间 */
  elapsedSinceQueuedMs?: string
  /** 自动检测模式 */
  levelAutoCheckMode?: string
  /** KYC级别 */
  levelName?: string
  /** 优先级 */
  priority?: string
  /** 重新处理 */
  reprocessing?: string
  /** 审核时间 */
  reviewDate?: string
  /** 审核唯一标识符 */
  reviewId?: string
  /** sumsub审核结果VO */
  reviewResult?: {
    /** 拒绝原因，不得向申请人显示 */
    clientComment?: string
    /** 审核评论，可以向申请人显示 */
    moderationComment?: string
    /** 一个或多个拒绝原因 */
    rejectLabels?: string[]
    /** 审阅结果 GREEN 申请人获得批准；RED 申请人被拒绝 */
    reviewAnswer?: string
    /** 指示拒绝的类型 FINAL 最终拒绝；RETRY 暂时拒绝 */
    reviewRejectType?: string
  }
  /** 审核状态 */
  reviewStatus?: string
}>
export const postTestKycSumsubReviewStatus = (
  params?: TPostTestKycSumsubReviewStatusParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostTestKycSumsubReviewStatusResponse>(API.TestKycSumsubReviewStatus, params, { options })
}

export type TPostTestKycSumsubTestCompletedParams = {
  clientComment?: string

  moderationComment?: string

  rejectLabels?: string[]

  reviewAnswer?: string

  reviewRejectType?: string
}
export type TPostTestKycSumsubTestCompletedResponse = TResponse<string>
export const postTestKycSumsubTestCompleted = (
  params?: TPostTestKycSumsubTestCompletedParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostTestKycSumsubTestCompletedResponse>(API.TestKycSumsubTestCompleted, params, { options })
}

export type TPostKycAmlbotCallbackParams = string
export type TPostKycAmlbotCallbackResponse = TResponse<any>
export const postKycAmlbotCallback = (params?: TPostKycAmlbotCallbackParams, options?: RequestOptions) => {
  return hcAxios.post<TPostKycAmlbotCallbackResponse>(API.KycAmlbotCallback, params, { options })
}

export type TPostKycAmlbotFormUrlParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostKycAmlbotFormUrlResponse = TResponse<string>
export const postKycAmlbotFormUrl = (params?: TPostKycAmlbotFormUrlParams, options?: RequestOptions) => {
  return hcAxios.post<TPostKycAmlbotFormUrlResponse>(API.KycAmlbotFormUrl, params, { options })
}

export type TPostTestKycAmlbotFormUrlParams = {
  city?: string

  client?: number

  country?: string

  domain?: string
  /** 认证类型 0, 个人普通认证 /  1,  高级认证---地址  / 2, 高级认证---水电清单 / 3,高级认证---信用卡账单 */
  fromType?: number

  street?: string

  userId?: number
}
export type TPostTestKycAmlbotFormUrlResponse = TResponse<string>
export const postTestKycAmlbotFormUrl = (params?: TPostTestKycAmlbotFormUrlParams, options?: RequestOptions) => {
  return hcAxios.post<TPostTestKycAmlbotFormUrlResponse>(API.TestKycAmlbotFormUrl, params, { options })
}

export type TPostKycAmlbotInitAuthenticationParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostKycAmlbotInitAuthenticationResponse = TResponse<any>
export const postKycAmlbotInitAuthentication = (
  params?: TPostKycAmlbotInitAuthenticationParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostKycAmlbotInitAuthenticationResponse>(API.KycAmlbotInitAuthentication, params, { options })
}

export type TGetRealPersonAuthGetVerifyTokenParams = any
export type TGetRealPersonAuthGetVerifyTokenResponse = TResponse<string>
export const getRealPersonAuthGetVerifyToken = (
  params?: TGetRealPersonAuthGetVerifyTokenParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetRealPersonAuthGetVerifyTokenResponse>(API.RealPersonAuthGetVerifyToken, { params, options })
}

export type TPostIdentityCompanyApplyParams = {
  identityCompanyFilesDTOs?: {
    /** 业务类型，详见COMPANY_FILE_BIZ_ENUM */
    bizType?: string

    createdTime?: string
    /** 文件名称 */
    fileName?: string
    /** 文件路径 */
    fileUrl?: string
    /** 用户id */
    fuid?: number
    /** 是否删除,默认0,0表示未删除 1表示删除 */
    isDeleted?: boolean

    updatedTime?: string
  }[]
  /** 企业认证-保存基础信息草稿DTO */
  identityCompanyInfoDTO?: {
    /** 申请原因 */
    applyReason?: string
    /** 联系电话区号，比如86 */
    areaCode?: string
    /** 城市 */
    city?: string
    /** 企业名称 */
    companyName?: string
    /** 企业注册号 */
    companyRegisterNumber?: string
    /** 联系电话 */
    contactNumber?: string
    /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
    corporateType?: string
    /** 国家/地区 */
    country?: string
    /** 审核状态 （-1 初始化 0 等待审核 1 通过审核 2 未通过审核） */
    fstatus?: number
    /** 用户id */
    fuid?: number
    /** 业务性质 */
    natureBusiness?: string
    /** 运营城市 */
    operatingCity?: string
    /** 运营国家/地区 */
    operatingCountry?: string
    /** 运营街道地址 */
    operatingStreet?: string
    /** 资金来源 */
    sourceFunding?: string
    /** 街道地址 */
    street?: string
  }

  identityCompanyMembersDTOs?: {
    /** 出生日期 */
    birthday?: string
    /** 国家/地区 */
    country?: string

    createdTime?: string
    /** 邮箱 */
    email?: string
    /** 名字 */
    fname?: string
    /** 证件类型（ 0 身份证 1 护照  2 驾驶证 ) */
    ftype?: number
    /** 用户id */
    fuid?: number
    /** 证件号 */
    idNumber?: string
    /** 个人肖像照 */
    imageBest?: string
    /** 最后一次上传的身份证国徽面 */
    imageIdcardBack?: string
    /** 最后一次上传的身份证人像面 */
    imageIdcardFront?: string
    /** 是否删除，0表示未删除 1表示删除 */
    isDeleted?: boolean
    /** 证件签发国/地区 */
    issuingCountry?: string
    /** 姓氏 */
    lastName?: string
    /** 企业认证资料类型 1董事 2最终收益权人 3账户交易员 */
    materialType?: number
    /** 中间名字 */
    middleName?: string
    /** 持股比例 */
    ownershipPercentage?: string

    updatedTime?: string
  }[]
}[]
export type TPostIdentityCompanyApplyResponse = TResponse<any>
export const postIdentityCompanyApply = (params?: TPostIdentityCompanyApplyParams, options?: RequestOptions) => {
  return hcAxios.post<TPostIdentityCompanyApplyResponse>(API.IdentityCompanyApply, params, { options })
}

export type TGetIdentityCompanyFilesInfoParams = {
  /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
  corporateType?: any
  /** 企业认证资料类型 1董事 2最终收益权人 3账户交易员 */
  materialType?: any
  /** 用户id */
  userId?: any
}
export type TGetIdentityCompanyFilesInfoResponse = TResponse<
  {
    /** 业务类型，1-公司注册证书及商业登记证原件，2-公司章程，3-最近十二个月内发行的董事名册，4-最近十二个月内发行的股东、会员名册，5-企业组织结构，6-政府网站链接公司信息截图，7-授权信，8-公司存续证明，9-补充资料,10-公司信息的政府网站链接 */
    bizType?: string
    /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
    corporateType?: string

    createdTime?: string
    /** 文件名称/公司信息的政府网站链接 */
    fileName?: string
    /** 文件路径 */
    fileUrl?: string
    /** 用户id */
    fuid?: number

    id?: number
    /** 是否删除,默认0,0表示未删除 1表示删除 */
    isDeleted?: boolean

    updatedTime?: string
  }[]
>
export const getIdentityCompanyFilesInfo = (params?: TGetIdentityCompanyFilesInfoParams, options?: RequestOptions) => {
  return hcAxios.get<TGetIdentityCompanyFilesInfoResponse>(API.IdentityCompanyFilesInfo, { params, options })
}

export type TPostIdentityCompanySaveFilesParams = {
  /** 业务类型，1-公司注册证书及商业登记证原件，2-公司章程，3-最近十二个月内发行的董事名册，4-最近十二个月内发行的股东、会员名册，5-企业组织结构，6-政府网站链接公司信息截图，7-授权信，8-公司存续证明，9-补充资料，,10-公司信息的政府网站链接 */
  bizType?: string
  /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
  corporateType?: string

  createdTime?: string
  /** 文件名称/bizType为10,是公司信息的政府网站链接 */
  fileName?: string
  /** 文件路径 */
  fileUrl?: string
  /** 用户id */
  fuid?: number
  /** 是否删除,默认0,0表示未删除 1表示删除 */
  isDeleted?: boolean

  updatedTime?: string
}[]
export type TPostIdentityCompanySaveFilesResponse = TResponse<number>
export const postIdentityCompanySaveFiles = (
  params?: TPostIdentityCompanySaveFilesParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostIdentityCompanySaveFilesResponse>(API.IdentityCompanySaveFiles, params, { options })
}

export type TPostIdentityStandardApplyParams = {
  /** 出生日期 */
  birthday?: string
  /** BVN */
  bvnCode?: string
  /** 证件背面 */
  cardBackPhotoUrl?: string
  /** 证件正面 */
  cardFrontPhotoUrl?: string
  /** 1-驾驶证 2-身份证 3-护照 4-居留许可证 */
  cardType?: number
  /** 国家或地区，例如中国 传CN */
  country?: string
  /** 证件号 */
  idNo?: string
  /** 姓 */
  lastName?: string
  /** 中间名字 */
  middleName?: string
  /** 姓名 */
  name?: string
  /** 人物信息图片 */
  realPersonPhotoUrl?: string
  /** 人脸视频URL */
  realPersonVideoUrl?: string
}
export type TPostIdentityStandardApplyResponse = TResponse<any>
export const postIdentityStandardApply = (params?: TPostIdentityStandardApplyParams, options?: RequestOptions) => {
  return hcAxios.post<TPostIdentityStandardApplyResponse>(API.IdentityStandardApply, params, { options })
}

export type TPostIdentityAdvancedApplyParams = {
  /** 地址证明 */
  addressProof?: string
  /** 城市 */
  city?: string
  /** 国家或地区，例如中国 传CN */
  country?: string
  /** 地址 */
  street?: string
}
export type TPostIdentityAdvancedApplyResponse = TResponse<any>
export const postIdentityAdvancedApply = (params?: TPostIdentityAdvancedApplyParams, options?: RequestOptions) => {
  return hcAxios.post<TPostIdentityAdvancedApplyResponse>(API.IdentityAdvancedApply, params, { options })
}

export type TGetIdentityCompanyBeneficiaryInfoParams = {
  /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
  corporateType?: any
  /** 企业认证资料类型 1董事 2最终收益权人 3账户交易员 */
  materialType?: any
  /** 用户id */
  userId?: any
}
export type TGetIdentityCompanyBeneficiaryInfoResponse = TResponse<
  {
    /** 出生日期 */
    birthday?: string
    /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
    corporateType?: string
    /** 国家/地区 */
    country?: string

    createdTime?: string
    /** 邮箱 */
    email?: string
    /** 名字 */
    fname?: string
    /** 证件类型（ 0 身份证 1 护照  2 驾驶证 ) */
    ftype?: number
    /** 用户id */
    fuid?: number

    id?: number
    /** 证件号 */
    idNumber?: string
    /** 个人肖像照 */
    imageBest?: string
    /** 最后一次上传的身份证国徽面 */
    imageIdcardBack?: string
    /** 最后一次上传的身份证人像面 */
    imageIdcardFront?: string
    /** 是否删除，0表示未删除 1表示删除 */
    isDeleted?: boolean
    /** 证件签发国/地区 */
    issuingCountry?: string
    /** 姓氏 */
    lastName?: string
    /** 企业认证资料类型 1董事 2最终收益权人 3账户交易员 */
    materialType?: number
    /** 中间名字 */
    middleName?: string
    /** 持股比例 */
    ownershipPercentage?: string

    updatedTime?: string
  }[]
>
export const getIdentityCompanyBeneficiaryInfo = (
  params?: TGetIdentityCompanyBeneficiaryInfoParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetIdentityCompanyBeneficiaryInfoResponse>(API.IdentityCompanyBeneficiaryInfo, {
    params,
    options,
  })
}

export type TGetIdentityCompanyDirectorInfoParams = {
  /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
  corporateType?: any
  /** 企业认证资料类型 1董事 2最终收益权人 3账户交易员 */
  materialType?: any
  /** 用户id */
  userId?: any
}
export type TGetIdentityCompanyDirectorInfoResponse = TResponse<
  {
    /** 出生日期 */
    birthday?: string
    /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
    corporateType?: string
    /** 国家/地区 */
    country?: string

    createdTime?: string
    /** 邮箱 */
    email?: string
    /** 名字 */
    fname?: string
    /** 证件类型（ 0 身份证 1 护照  2 驾驶证 ) */
    ftype?: number
    /** 用户id */
    fuid?: number

    id?: number
    /** 证件号 */
    idNumber?: string
    /** 个人肖像照 */
    imageBest?: string
    /** 最后一次上传的身份证国徽面 */
    imageIdcardBack?: string
    /** 最后一次上传的身份证人像面 */
    imageIdcardFront?: string
    /** 是否删除，0表示未删除 1表示删除 */
    isDeleted?: boolean
    /** 证件签发国/地区 */
    issuingCountry?: string
    /** 姓氏 */
    lastName?: string
    /** 企业认证资料类型 1董事 2最终收益权人 3账户交易员 */
    materialType?: number
    /** 中间名字 */
    middleName?: string
    /** 持股比例 */
    ownershipPercentage?: string

    updatedTime?: string
  }[]
>
export const getIdentityCompanyDirectorInfo = (
  params?: TGetIdentityCompanyDirectorInfoParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetIdentityCompanyDirectorInfoResponse>(API.IdentityCompanyDirectorInfo, { params, options })
}

export type TPostIdentityCompanySaveBeneficiaryParams = {
  /** 出生日期 */
  birthday?: string
  /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
  corporateType?: string
  /** 国家/地区 */
  country?: string

  createdTime?: string
  /** 名字 */
  fname?: string
  /** 证件类型（ 0 身份证 1 护照  2 驾驶证 ) */
  ftype?: number
  /** 用户id */
  fuid?: number
  /** 证件号 */
  idNumber?: string
  /** 个人肖像照 */
  imageBest?: string
  /** 身份证国徽面 */
  imageIdcardBack?: string
  /** 身份证人像面/护照活驾驶证信息页 */
  imageIdcardFront?: string
  /** 是否删除，0表示未删除 1表示删除 */
  isDeleted?: boolean
  /** 证件签发国/地区 */
  issuingCountry?: string
  /** 姓氏 */
  lastName?: string
  /** 企业认证资料类型 1董事 2最终收益权人 3账户交易员 */
  materialType?: number
  /** 中间名字 */
  middleName?: string

  updatedTime?: string
}[]
export type TPostIdentityCompanySaveBeneficiaryResponse = TResponse<number>
export const postIdentityCompanySaveBeneficiary = (
  params?: TPostIdentityCompanySaveBeneficiaryParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostIdentityCompanySaveBeneficiaryResponse>(API.IdentityCompanySaveBeneficiary, params, {
    options,
  })
}

export type TPostIdentityCompanySaveDirectorParams = {
  /** 出生日期 */
  birthday?: string
  /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
  corporateType?: string
  /** 国家/地区 */
  country?: string

  createdTime?: string
  /** 名字 */
  fname?: string
  /** 证件类型（ 0 身份证 1 护照  2 驾驶证 ) */
  ftype?: number
  /** 用户id */
  fuid?: number
  /** 证件号 */
  idNumber?: string
  /** 个人肖像照 */
  imageBest?: string
  /** 身份证国徽面 */
  imageIdcardBack?: string
  /** 身份证人像面/护照活驾驶证信息页 */
  imageIdcardFront?: string
  /** 是否删除，0表示未删除 1表示删除 */
  isDeleted?: boolean
  /** 证件签发国/地区 */
  issuingCountry?: string
  /** 姓氏 */
  lastName?: string
  /** 企业认证资料类型 1董事 2最终收益权人 3账户交易员 */
  materialType?: number
  /** 中间名字 */
  middleName?: string

  updatedTime?: string
}[]
export type TPostIdentityCompanySaveDirectorResponse = TResponse<number>
export const postIdentityCompanySaveDirector = (
  params?: TPostIdentityCompanySaveDirectorParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostIdentityCompanySaveDirectorResponse>(API.IdentityCompanySaveDirector, params, { options })
}

export type TPostIdentityCompanySaveTraderParams = {
  /** 出生日期 */
  birthday?: string
  /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
  corporateType?: string
  /** 国家/地区 */
  country?: string

  createdTime?: string
  /** 名字 */
  fname?: string
  /** 证件类型（ 0 身份证 1 护照  2 驾驶证 ) */
  ftype?: number
  /** 用户id */
  fuid?: number
  /** 证件号 */
  idNumber?: string
  /** 个人肖像照 */
  imageBest?: string
  /** 身份证国徽面 */
  imageIdcardBack?: string
  /** 身份证人像面/护照活驾驶证信息页 */
  imageIdcardFront?: string
  /** 是否删除，0表示未删除 1表示删除 */
  isDeleted?: boolean
  /** 证件签发国/地区 */
  issuingCountry?: string
  /** 姓氏 */
  lastName?: string
  /** 企业认证资料类型 1董事 2最终收益权人 3账户交易员 */
  materialType?: number
  /** 中间名字 */
  middleName?: string

  updatedTime?: string
}[]
export type TPostIdentityCompanySaveTraderResponse = TResponse<number>
export const postIdentityCompanySaveTrader = (
  params?: TPostIdentityCompanySaveTraderParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostIdentityCompanySaveTraderResponse>(API.IdentityCompanySaveTrader, params, { options })
}

export type TGetIdentityCompanyTraderInfoParams = {
  /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
  corporateType?: any
  /** 企业认证资料类型 1董事 2最终收益权人 3账户交易员 */
  materialType?: any
  /** 用户id */
  userId?: any
}
export type TGetIdentityCompanyTraderInfoResponse = TResponse<
  {
    /** 出生日期 */
    birthday?: string
    /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
    corporateType?: string
    /** 国家/地区 */
    country?: string

    createdTime?: string
    /** 邮箱 */
    email?: string
    /** 名字 */
    fname?: string
    /** 证件类型（ 0 身份证 1 护照  2 驾驶证 ) */
    ftype?: number
    /** 用户id */
    fuid?: number

    id?: number
    /** 证件号 */
    idNumber?: string
    /** 个人肖像照 */
    imageBest?: string
    /** 最后一次上传的身份证国徽面 */
    imageIdcardBack?: string
    /** 最后一次上传的身份证人像面 */
    imageIdcardFront?: string
    /** 是否删除，0表示未删除 1表示删除 */
    isDeleted?: boolean
    /** 证件签发国/地区 */
    issuingCountry?: string
    /** 姓氏 */
    lastName?: string
    /** 企业认证资料类型 1董事 2最终收益权人 3账户交易员 */
    materialType?: number
    /** 中间名字 */
    middleName?: string
    /** 持股比例 */
    ownershipPercentage?: string

    updatedTime?: string
  }[]
>
export const getIdentityCompanyTraderInfo = (
  params?: TGetIdentityCompanyTraderInfoParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetIdentityCompanyTraderInfoResponse>(API.IdentityCompanyTraderInfo, { params, options })
}

export type TGetIdentityStatusParams = any
export type TGetIdentityStatusResponse = TResponse<{
  /** 国家简称 */
  country?: string
  /** 用户认证状态 */
  statusList?: {
    /** 身份认证状态 0等待审核 1审核通过 2审核不通过 3未认证 */
    identityStatus?: number
    /** 身份认证类型 0未认证 1个人标准认证 2个人高级认证 3企业认证 */
    identityType?: number
  }[]
}>
export const getIdentityStatus = (params?: TGetIdentityStatusParams, options?: RequestOptions) => {
  return hcAxios.get<TGetIdentityStatusResponse>(API.IdentityStatus, { params, options })
}

export type TGetIdentityGetUserRightsParams = any
export type TGetIdentityGetUserRightsResponse = TResponse<
  {
    /** 身份认证状态 0等待审核 1审核通过 2审核不通过 3未认证 */
    identityStatus?: number
    /** 驳回理由 */
    reason?: string
  }[]
>
export const getIdentityGetUserRights = (params?: TGetIdentityGetUserRightsParams, options?: RequestOptions) => {
  return hcAxios.get<TGetIdentityGetUserRightsResponse>(API.IdentityGetUserRights, { params, options })
}

export type TGetIdentityGetVerifyResultParams = {
  /** 身份认证类型 1个人标准认证 2个人高级认证 3企业认证 */
  identityType?: any
  /** uid */
  userId?: any
}
export type TGetIdentityGetVerifyResultResponse = TResponse<{
  /** 身份认证状态 0等待审核 1审核通过 2审核不通过 3未认证 */
  identityStatus?: number
  /** 驳回理由 */
  reason?: string
}>
export const getIdentityGetVerifyResult = (params?: TGetIdentityGetVerifyResultParams, options?: RequestOptions) => {
  return hcAxios.get<TGetIdentityGetVerifyResultResponse>(API.IdentityGetVerifyResult, { params, options })
}

export type TGetIdentityCompanyBasicInfoParams = {
  /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
  corporateType?: any
  /** 企业认证资料类型 1董事 2最终收益权人 3账户交易员 */
  materialType?: any
  /** 用户id */
  userId?: any
}
export type TGetIdentityCompanyBasicInfoResponse = TResponse<{
  /** 申请原因 */
  applyReason?: string
  /** 联系电话区号，比如86 */
  areaCode?: string
  /** 城市 */
  city?: string
  /** 企业名称 */
  companyName?: string
  /** 企业注册号 */
  companyRegisterNumber?: string
  /** 联系电话 */
  contactNumber?: string
  /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
  corporateType?: string
  /** 国家/地区 */
  country?: string
  /** 创建人 */
  createdBy?: string
  /** 创建时间 */
  createdTime?: string
  /** 审核时间 */
  fauthtime?: string
  /** 审核状态 （-1 初始化 0 等待审核 1 通过审核 2 未通过审核） */
  fstatus?: number
  /** 用户id */
  fuid?: number

  id?: number
  /** 最近申请时间 */
  lastAppyTime?: string
  /** 审核人 */
  modifyUserId?: number
  /** 业务性质 */
  natureBusiness?: string
  /** 运营城市 */
  operatingCity?: string
  /** 运营国家/地区 */
  operatingCountry?: string
  /** 运营街道地址 */
  operatingStreet?: string
  /** 审核备注 */
  remark?: string
  /** 资金来源 */
  sourceFunding?: string
  /** 街道地址 */
  street?: string
  /** 更新人 */
  updatedBy?: string
  /** 更新时间 */
  updatedTime?: string
}>
export const getIdentityCompanyBasicInfo = (params?: TGetIdentityCompanyBasicInfoParams, options?: RequestOptions) => {
  return hcAxios.get<TGetIdentityCompanyBasicInfoResponse>(API.IdentityCompanyBasicInfo, { params, options })
}

export type TPostIdentityCompanySaveBasicInfoParams = {
  /** 申请原因 */
  applyReason?: string
  /** 联系电话区号，比如86 */
  areaCode?: string
  /** 城市 */
  city?: string
  /** 企业名称 */
  companyName?: string
  /** 企业注册号 */
  companyRegisterNumber?: string
  /** 联系电话 */
  contactNumber?: string
  /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
  corporateType?: string
  /** 国家/地区 */
  country?: string
  /** 审核状态 （-1 初始化 0 等待审核 1 通过审核 2 未通过审核） */
  fstatus?: number
  /** 用户id */
  fuid?: number
  /** 业务性质 */
  natureBusiness?: string
  /** 运营城市 */
  operatingCity?: string
  /** 运营国家/地区 */
  operatingCountry?: string
  /** 运营街道地址 */
  operatingStreet?: string
  /** 资金来源 */
  sourceFunding?: string
  /** 街道地址 */
  street?: string
}
export type TPostIdentityCompanySaveBasicInfoResponse = TResponse<number>
export const postIdentityCompanySaveBasicInfo = (
  params?: TPostIdentityCompanySaveBasicInfoParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostIdentityCompanySaveBasicInfoResponse>(API.IdentityCompanySaveBasicInfo, params, { options })
}

export type TGetIdentityCompanyTemplateFileParams = any
export type TGetIdentityCompanyTemplateFileResponse = TResponse<
  {
    /** 申请原因 */
    applyReason?: string
    /** 联系电话区号，比如86 */
    areaCode?: string
    /** 城市 */
    city?: string
    /** 企业名称 */
    companyName?: string
    /** 企业注册号 */
    companyRegisterNumber?: string
    /** 联系电话 */
    contactNumber?: string
    /** 企业类型 Incorporation有限责任公司 Trust信托 Others其他 */
    corporateType?: string
    /** 国家/地区 */
    country?: string
    /** 创建人 */
    createdBy?: string
    /** 创建时间 */
    createdTime?: string
    /** 审核时间 */
    fauthtime?: string
    /** 审核状态 （-1 初始化 0 等待审核 1 通过审核 2 未通过审核） */
    fstatus?: number
    /** 用户id */
    fuid?: number

    id?: number
    /** 最近申请时间 */
    lastAppyTime?: string
    /** 审核人 */
    modifyUserId?: number
    /** 业务性质 */
    natureBusiness?: string
    /** 运营城市 */
    operatingCity?: string
    /** 运营国家/地区 */
    operatingCountry?: string
    /** 运营街道地址 */
    operatingStreet?: string
    /** 审核备注 */
    remark?: string
    /** 资金来源 */
    sourceFunding?: string
    /** 街道地址 */
    street?: string
    /** 更新人 */
    updatedBy?: string
    /** 更新时间 */
    updatedTime?: string
  }[]
>
export const getIdentityCompanyTemplateFile = (
  params?: TGetIdentityCompanyTemplateFileParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetIdentityCompanyTemplateFileResponse>(API.IdentityCompanyTemplateFile, { params, options })
}
